import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  IMAGE_SRC,
  VALIDATION_MESSAGE,
} from 'src/app/components/shared/shared-constants';
import { CONSTS } from './from-to-date.constants';

@Component({
  selector: 'app-from-to-date',
  templateUrl: './from-to-date.component.html',
  styleUrls: ['./from-to-date.component.scss'],
  standalone: false,
})
export class FromToDateComponent implements OnInit {
  @Input() fromControl!: string;
  @Input() toControl!: string;
  @Input() formGroupValue!: FormGroup;
  @Input() minSelectableDays = 30;
  @Input() customMinFromDate!: Date | null;
  @Input() customMaxFromDate!: Date | null;
  @Input() customMaxToDate!: Date | null;
  @Input() customMinToDate!: Date | null;
  CONSTS = { ...CONSTS, ...VALIDATION_MESSAGE };
  SRC = IMAGE_SRC;

  currDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  hasDateError = false;

  ngOnInit(): void {
    this.currDate = new Date();
    this.minDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() - this.minSelectableDays,
    );
    this.maxDate = new Date(
      this.currDate.getFullYear(),
      this.currDate.getMonth(),
      this.currDate.getDate() + 14,
    );
  }

  updateValue() {
    this.hasDateError = this.dateLessThan(
      this.formGroupValue?.get(this.fromControl)?.value,
      this.formGroupValue?.get(this.toControl)?.value,
    );
    if (this.hasDateError) {
      this.formGroupValue.setErrors({ ['invalidDate']: this.hasDateError });
    } else {
      this.formGroupValue.updateValueAndValidity();
    }
  }

  private dateLessThan(from: string, to: string): boolean {
    const fromDate = new Date(from);
    const toDate = new Date(to);
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
    return fromDate.getTime() > toDate.getTime();
  }
}
